export const CALENDAR = 'Calendar'
export const CALENDAR_HEIGHT = '700px'
export const TURN_OFF = 'Turn Off'
export const TURN_ON = 'Turn On'
export const UPCOMING_NEWSLETTERS = 'Upcoming Newsletters'
export const SCHEDULE = 'SCHEDULE'
